const marketTypes = {
  DAY_AHEAD: 'DAYAHEAD',
  SAME_DAY: 'SAMEDAY',
};

export default marketTypes;
